import React from "react";
import './Event.css';

import { extractDateParts } from "../../utils";

import { FaClock } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

import { Link } from "react-router-dom";



const Event = ({ event }) => {

    const { weekday, day, shortMonth } = extractDateParts(event.details.date); // Extracting formatted date parts using utility function

    return (

        <div className="event-item">

            <img src={event.image} alt={event.title} /> {/* Event Image */}

            <div className="content">

                <div className="date">{weekday} <br></br> <span>{day}</span> {shortMonth}</div> {/* Event Date */}

                {/* Link to the individual Event page */}
                <Link
                    to={{
                        pathname: '/Events/' + event.title,  // Navigate to the specific Event page
                    }}
                    location = {{event}}  // Passing Event details to the linked page
                    className="main-heading"
                    state= {event}> 
                    {event.title} {/* Event Title */}
                </Link>

                {/* Event details section */}
                <div className='details'>

                    {/* Event Time */}
                    <h3>
                        <div className='icon'><FaClock /></div>
                        <span>{event.details.time}</span>
                    </h3>

                    {/* Event Location */}
                    <h3>
                        <div className='icon'><FaLocationDot /></div>
                        <span>{event.details.location}</span>
                    </h3>

                </div>

            </div>

        </div>
    );
};

export default Event;